// EngagementTab - Sistema de pestañas principal
// Tabs: Dashboard | Compradores | Pujas

import React, { useState } from 'react';
import { BarChart3, Users, Trophy } from 'lucide-react';
import { DashboardView } from './DashboardView';
import { BuyersView } from './BuyersView';
import { BidsRankingView } from './BidsRankingView';

/**
 * Tab principal de Engagement
 * Recibe datos de engagement por props (carga gestionada por padre)
 */
export const EngagementTab = ({ property, buyerSummaries = [], loading = false, isSpectatorMode = false }) => {
  const [activeTab, setActiveTab] = useState('dashboard');

  // Tabs disponibles
  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3 },
    { id: 'buyers', label: 'Compradores', icon: Users },
    { id: 'bids', label: 'Pujas', icon: Trophy },
  ];

  if (!property) {
    return (
      <div className="text-center py-12 text-slate-400">
        No hay propiedad seleccionada
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Tabs - estilo pestañas clásico */}
      <div className="flex border-b border-slate-700">
        {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium transition-all border-b-2 -mb-px ${
                isActive
                  ? 'border-amber-500 text-amber-400 bg-slate-800/30'
                  : 'border-transparent text-slate-400 hover:text-white hover:border-slate-500'
              }`}
            >
              <Icon className="w-5 h-5" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Contenido de la pestaña activa */}
      <div className="min-h-[400px]">
        {loading && buyerSummaries.length === 0 ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500 mb-4"></div>
            <p className="text-slate-400">Cargando datos de engagement...</p>
          </div>
        ) : (
          <>
            {activeTab === 'dashboard' && (
              <DashboardView
                buyerSummaries={buyerSummaries}
                property={property}
                isSpectatorMode={isSpectatorMode}
              />
            )}
            {activeTab === 'buyers' && (
              <BuyersView
                buyerSummaries={buyerSummaries}
                propertyId={property.id}
                property={property}
                isSpectatorMode={isSpectatorMode}
              />
            )}
            {activeTab === 'bids' && (
              <BidsRankingView
                buyerSummaries={buyerSummaries}
                propertyId={property.id}
                isSpectatorMode={isSpectatorMode}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default EngagementTab;
